<template>
<v-container style="text-align:center">
  <h1>HortusTeam</h1>
  <br/>
  <v-row align="center" justify="space-around">
    
    <div class="ma-3" v-for="(collab, i) in collabs" :key="i">
      <v-avatar :size="$vuetify.breakpoint.smAndDown ? 100 : 120">
        <v-img :src="collab.avatar" contain />
      </v-avatar>
      <h3>{{collab.name}}</h3>
      <h4 class="font-weight-thin">{{collab.title}}</h4>
    </div>

  </v-row>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  computed: {
    ...mapGetters('strapi', ['collabs']),
  },
  methods: {
    ...mapActions('strapi', ['getCollab']),
  },
  async mounted () {
    this.getCollab()
  }
}
</script>

<style scoped>
h3 {
  margin-top: 1em;
}
</style>